import { Box, Tooltip } from "@mui/material";
import { regularRegistrationTaskMenu } from "data/constants";
import useQueryParams from "hooks/useQueryParams";
import { useNavigate } from "react-router-dom";
import { StyledProfileNav, StyledProfileNavItem } from "views/clients/styles";
import useTitle from "hooks/useTitle";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Permissions } from "data/permissons";
import { usePermissions } from "context/PermissionsProvider";
import AccessDenied from "views/atom-pro/Access/accessDenide";
import IffTask from "views/register/GstReturns/Regular/ReturnTypes/Iff/taskIff";
import Gstr3bTask from "views/register/GstReturns/Regular/ReturnTypes/Gstr-3b/gstr3bTask";
import Gstr9Task from "views/register/GstReturns/Regular/ReturnTypes/Gstr-9/gstr9Task";

function GstrTaskIndex() {
  useTitle("Sync GST & Tasks");
  const { permissions } = usePermissions();
  const navigate = useNavigate();
  const { queryParams } = useQueryParams();
  const active = queryParams.tab;

  if (!(permissions.includes(Permissions.VIEW_ALL_CLIENT_MANAGERS) || permissions.includes(Permissions.VIEW_ASSIGNED_CLIENT_MANAGERS))) {
    return <AccessDenied />
  }

  return (
    <>
      <Box sx={{ position: "sticky", top: 65, bgcolor: "white", zIndex: 2 }}>
        <StyledProfileNav>
          {regularRegistrationTaskMenu?.map((item, index) => (
            <StyledProfileNavItem
              key={index}
              onClick={() => navigate(`?tab=${item.title}`)}
              active={active === item.title ? 1 : 0}
            >
              <Box sx={{ marginTop: 0, display: "flex" }}>
                {item.title}
                {item?.tool && <Tooltip title={item?.tool}>
                  <HelpOutlineIcon fontSize="small" sx={{ marginTop: "2px" }} />
                </Tooltip>}
              </Box>
            </StyledProfileNavItem>
          ))}
        </StyledProfileNav>
      </Box>
      <Box px={2} py={3} pb={0} mb={0}>
        {active === "GSTR-1/IFF" && <IffTask />}
        {active === "GSTR-3B" && <Gstr3bTask />}
        {active === "GSTR-9" && <Gstr9Task />}
      </Box>
    </>
  );
}

export default GstrTaskIndex;

